export const SITE_CONFIG = {
  businessName: "Cactus Rose Needle Arts",
  shortName: "Cactus Rose",
  founders: ["Derek", "Brent"],
  brand: {
    logoOriginal: "/assets/brand/cactus-rose-logo-original.png",
    logoTransparent: "/assets/brand/cactus-rose-logo-transparent.png",
  },
  location: {
    addressLine1: "1717 S Decatur Blvd, Booth C25",
    addressLine2: "Las Vegas, NV 89102",
    booth: "C25",
    venue: "Inside the Fantastic Indoor Swap Meet",
  },
  hours: {
    openDays: "Friday–Sunday",
    openTime: "10:00 AM–6:00 PM",
    closedDays: "Closed Monday–Thursday",
    rows: [
      ["Monday–Thursday", "Closed"],
      ["Friday–Sunday", "10:00 AM–6:00 PM"],
    ],
  },
  phone: {
    display: "702-202-9909",
    href: "tel:+17022029909",
  },
  inventory: {
    notice:
      "Online availability may differ from what is currently available in the Las Vegas shop. If you are visiting for a specific item, please call us first at 702-202-9909.",
    shortNotice:
      "Online and Las Vegas shop availability may differ. Call ahead for a specific item.",
  },
  links: {
    shopify: "https://cactusroseneedlearts.com/",
    directions:
      "https://www.google.com/maps/search/?api=1&query=1717%20S%20Decatur%20Blvd%20Booth%20C25%20Las%20Vegas%20NV%2089102",
  },
};
